import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import rightimg from "../../../images/Arrow - Right 2.png";
import activerightimg from "../../../images/Arrow - Right  active.png";
import { useParams } from 'react-router-dom';
const Blogcategory = ({ data }) => {
    const location = useLocation();
    const { slug } = useParams();
    return (
        <div className="mytractrightside">
              <div className="recentblogtitle">Categories</div>
            {
                data?.map(ele => {
                    const isActive =
                        slug == ele.url;

                    return (
                        <NavLink
                            key={ele.id}
                            to={`/blogs/${ele.url}/${ele.id}`}
                            className={`blogcat-main textdecoration-none ${isActive ? 'active-blog-category' : ''}`}
                        >
                            {
                                isActive ?
                                    <img className="blog-cat-rightarrowimg" src={activerightimg} alt="arrow" /> :
                                    <img className="blog-cat-rightarrowimg" src={rightimg} alt="arrow" />
                            }


                            {ele.name}
                        </NavLink>
                    );
                })
            }
        </div>
    );
};

export default Blogcategory;
